import { Box, Table, TableCell, TableContainer, TableRow } from '@mui/material';
import { FC } from 'react';
import {
	INTEGRATIONS_PLATFORMS_IMG,
	IntegrationsPlatform,
} from 'redux/reducers/integrations/constants';
import { CountryWithFlag } from 'ui/CountryWithFlag';

export type TStep5Props = {
	platform: IntegrationsPlatform;
	APIKey: string;
	keyID: string;
	storeID: string;
	storeAddress: string;

	hsCode: string | null;
	selectedCountry: string;
};
export const Step5: FC<TStep5Props> = ({
	platform,
	APIKey,
	keyID,
	storeID,
	storeAddress,
	hsCode,
	selectedCountry,
}) => {
	return (
		<TableContainer
			sx={{
				'& .MuiTableCell-root': {
					border: 'none',
				},
			}}
		>
			<Table>
				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						Integration Platform:
					</TableCell>{' '}
					<TableCell sx={{ fontWeight: 'bold', color: '#016193', p: '8px' }}>
						<img
							src={INTEGRATIONS_PLATFORMS_IMG[platform] ?? ''}
							alt=""
							style={{
								height: '20px',
							}}
						/>
					</TableCell>
				</TableRow>
				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						Store Address:
					</TableCell>
					<TableCell sx={{ p: '8px' }}>
						<span style={{ fontWeight: 'bold', color: '#016193' }}>{storeAddress}</span>
					</TableCell>
				</TableRow>

				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						Country:
					</TableCell>
					<TableCell sx={{ fontWeight: 'bold', color: '#016193', p: '8px' }}>
						{selectedCountry && <CountryWithFlag countryCode={selectedCountry} bold />}
					</TableCell>
				</TableRow>
				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						Store ID:
					</TableCell>{' '}
					<TableCell sx={{ p: '8px' }}>
						<span style={{ fontWeight: 'bold', color: '#016193' }}>{storeID}</span>
					</TableCell>
				</TableRow>

				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						API Token:
					</TableCell>
					<TableCell
						sx={{
							p: '8px',
							maxWidth: '200px',
							// overflow: 'hidden',
							// textOverflow: 'ellipsis',
							// whiteSpace: 'normal',
							height: 'auto',
							overflowWrap: 'break-word',
							wordWreak: 'break-word',
						}}
					>
						<span
							style={{
								// maxWidth: '200px',
								fontWeight: 'bold',
								color: '#016193',
								// whiteSpace: 'pre-wrap',
								// height: 'auto',
							}}
						>
							{APIKey}
						</span>
					</TableCell>
				</TableRow>
				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						Account ID:
					</TableCell>
					<TableCell sx={{ p: '8px' }}>
						<span style={{ fontWeight: 'bold', color: '#016193' }}>{keyID}</span>
					</TableCell>
				</TableRow>
				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						HS Code:
					</TableCell>
					<TableCell sx={{ p: '8px' }}>
						<span style={{ fontWeight: 'bold', color: '#016193' }}>{hsCode ?? '\u2014'}</span>
					</TableCell>
				</TableRow>
			</Table>
		</TableContainer>
	);
};
